import { useEffect, useRef, useState } from 'react';

/**
 * Painel flutuante que fecha por Esc, por clique fora e ao perder o foco.
 *
 * Os três precisam existir juntos. Só clique fora deixa o teclado preso: quem
 * abriu com Enter não tem como fechar. Só Esc deixa dois painéis abertos ao
 * mesmo tempo se o usuário clicar de um para o outro.
 *
 * Ao fechar, o foco volta ao botão que abriu — senão ele cai no início do
 * documento e a próxima tabulação recomeça da barra lateral.
 */
export function usePainel() {
  const [aberto, setAberto] = useState(false);
  const raiz = useRef<HTMLDivElement>(null);
  const gatilho = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!aberto) return;

    const aoTeclar = (evento: KeyboardEvent) => {
      if (evento.key !== 'Escape') return;
      setAberto(false);
      gatilho.current?.focus();
    };
    const aoClicar = (evento: MouseEvent) => {
      if (!raiz.current?.contains(evento.target as Node)) setAberto(false);
    };
    const aoFocar = (evento: FocusEvent) => {
      if (!raiz.current?.contains(evento.target as Node)) setAberto(false);
    };

    document.addEventListener('keydown', aoTeclar);
    document.addEventListener('mousedown', aoClicar);
    document.addEventListener('focusin', aoFocar);
    return () => {
      document.removeEventListener('keydown', aoTeclar);
      document.removeEventListener('mousedown', aoClicar);
      document.removeEventListener('focusin', aoFocar);
    };
  }, [aberto]);

  return { aberto, setAberto, raiz, gatilho };
}
